<script setup lang="ts">
import { CSidebar } from '@coreui/vue-pro'
const useVisualConfig = useVisualConfigStore()
const { toggleSidebar } = useVisualConfig
const { sidebarVisible, unfoldableState } = storeToRefs(useVisualConfig)
const APP_NAME = import.meta.env.VITE_APP_NAME

const themeStore = useThemeStore()
const { theme } = storeToRefs(themeStore)

const changeFoldableState = () => {
  if (unfoldableState.value) {
    unfoldableState.value = false
  } else {
    unfoldableState.value = true
  }
}

useVisualConfig.$subscribe((mutations, state) => {
  if (mutations.events.newValue === true) {
    setTimeout(() => {
      if (document.querySelector('.sidebar-backdrop')) {
        document.querySelector('.sidebar-backdrop').addEventListener('click', toggleSidebar)
      }
    }, 0)
  }
})
</script>

<template>
  <CSidebar position="fixed" :unfoldable="unfoldableState" :visible="sidebarVisible">
    <CSidebarBrand :class="{ 'px-5': !unfoldableState }" class="apside">
      <RouterLink to="/dashboard">
        <CImage
          v-if="theme === 'dark'"
          fluid
          src="/logo-bmotion-blanco-sm.png"
          style="max-width: 93px; margin-top: -2px; margin-bottom: 12px"
        />
        <CImage
          v-if="theme === 'light'"
          fluid
          src="/logo-bmotion-negro-sm.png"
          style="max-width: 93px; margin-top: -2px; margin-bottom: 12px"
        />
        <h1>
          <strong>{{ APP_NAME }}</strong>
        </h1>
      </RouterLink>
    </CSidebarBrand>
    <CSidebarNav>
      <slot name="navList"></slot>
    </CSidebarNav>
    <CSidebarToggler @click="changeFoldableState()" />
  </CSidebar>
</template>
